import React from 'react'

type Props = {
  className?: string
  fill: string
  size: string
}

const CheckCircle = ({ className, fill, size }: Props) => (
  <svg
    className={className}
    fill={fill}
    height={size}
    viewBox='0 0 24 24'
    width={size}
    xmlns='http://www.w3.org/2000/svg'
  >
    <path d='M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM9.6 18L3.6 12L5.292 10.308L9.6 14.604L18.708 5.496L20.4 7.2L9.6 18Z' />
  </svg>
)

CheckCircle.defaultProps = {
  className: ''
}

export default CheckCircle
